import { render, staticRenderFns } from "./plan-produccion-ecologica.vue?vue&type=template&id=51b5fd18&scoped=true&"
import script from "./plan-produccion-ecologica.vue?vue&type=script&lang=js&"
export * from "./plan-produccion-ecologica.vue?vue&type=script&lang=js&"
import style0 from "./plan-produccion-ecologica.vue?vue&type=style&index=0&id=51b5fd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5fd18",
  null
  
)

export default component.exports